export enum Rating {
    One = 1,
    Two,
    Three,
    Four,
    Five
}